<template>
  <router-view></router-view>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'getLogin'
    ]),
  },
  created () {
    // replace url route when sso string found
    const tokenAccountRegex = new RegExp(/\?token=.*?\&account_id=.*?/)
    let url = String(window.location.href)
    if ((typeof window.history.pushState === 'function') && tokenAccountRegex.test(url)) {
      window.history.pushState({}, 0, this.$route.path)
    }
    // <=ie9
    // if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    if(this.isLowVersionIE()) {
      this.$notify({
        title: '推荐使用',
        message: 'IE10以上或chrome浏览器',
        type: 'warning'
      })
    }
  },
  methods: {
    isLowVersionIE: ()=>{
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
      var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
      if(isIE) {
          var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
          reIE.test(userAgent);
          var fIEVersion = parseFloat(RegExp["$1"]);
          if(fIEVersion == 10) {
              return false;
          } else {
              return true;//IE版本<=9
          }   
      } else {
          return false;//不是ie10以下浏览器
      }
    }
  },
}
</script>

<style lang="stylus">
@import "~styl/mixins"
@import "~styl/variables"

html 
  font-size: 100px
  -webkit-font-smoothing: antialiased
  height: 100%
  color: color-main
body
  margin: 0; padding: 0
  font-size: .14rem
  height: 100%
p, div, span ,a,ul,li
  margin: 0
  padding: 0
a,img
  text-decoration none
  outline none
img
  border:none
*
  font-family: 'Helvetica Neue',Helvetica,'PingFang SC','Hiragino Sans GB','Microsoft YaHei','SimSun',sans-serif
  box-sizing: border-box
.fade-enter-active, .fade-leave-active
  transition: opacity .4s ease
.fade-enter, .fade-leave-active
  opacity: 0
</style>



// WEBPACK FOOTER //
// app/App.vue